import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';

export const navbarStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        mainToolbar: {
            backgroundColor: '#575756',
        },
        mainLogo: {
            position: 'absolute',
            backgroundColor: '#b6000f',
            height: '48px',
            width: '104px',
            left: '0',
        },
        logo: {
            height: "100%",
            width: '100%',
        },
        sectionDesktop: {
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'flex',
            },
        },
        userButton: {
            marginLeft: '10px', 
            textTransform: 'none', 
            fontWeight: 'bold', 
            color:'#fff',
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
        },
        menuButton: {
            marginRight: theme.spacing(2),
            color: '#575756',
        },
    }),
);